/* INTEGY V690 — mobile drawer visual-viewport + scroll guard. */
(function () {
  'use strict';
  var root = document.documentElement;
  var lastOpen = false;

  function viewportHeight() {
    var vv = window.visualViewport;
    return Math.max(240, Math.round(vv && vv.height ? vv.height : window.innerHeight || 0));
  }

  function syncViewport() {
    root.style.setProperty('--integy-v690-mobile-vh', viewportHeight() + 'px');
  }

  function fixOpenDrawer() {
    var nav = document.querySelector('.site-mobile-nav[data-open="true"], [data-mobile-nav][data-open="true"]');
    var open = !!nav;
    if (!open) { lastOpen = false; return; }
    syncViewport();
    var panel = nav.querySelector('.mobile-nav-panel, [data-mobile-nav-panel]');
    if (!panel) return;

    panel.style.setProperty('overflow-x', 'hidden', 'important');
    panel.style.setProperty('overflow-y', 'auto', 'important');
    panel.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    panel.style.setProperty('touch-action', 'pan-y', 'important');
    panel.style.setProperty('height', 'var(--integy-v690-mobile-vh)', 'important');
    panel.style.setProperty('max-height', 'var(--integy-v690-mobile-vh)', 'important');
    panel.setAttribute('data-integy-v690-scroll-owner', 'true');

    /* Do not reset a user's scroll position when submenus open/close. */
    if (!lastOpen && panel.scrollTop < 0) panel.scrollTop = 0;
    lastOpen = true;
  }

  function scheduleFix() {
    syncViewport();
    requestAnimationFrame(function () {
      fixOpenDrawer();
      setTimeout(fixOpenDrawer, 80);
      setTimeout(fixOpenDrawer, 380);
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleFix, { once: true });
  window.addEventListener('resize', scheduleFix, { passive: true });
  window.addEventListener('orientationchange', scheduleFix, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleFix, { passive: true });
    window.visualViewport.addEventListener('scroll', syncViewport, { passive: true });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && (m.attributeName === 'data-open' || m.attributeName === 'data-animation' || m.attributeName === 'data-animation-state' || m.attributeName === 'open')) {
        scheduleFix();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-open','data-animation','data-animation-state','open'] });
})();
